import React, { useEffect } from "react";
import { Chart } from "react-google-charts";
import { getGraphBackgroundColor } from "../../../../utils/utils";

const options: any = {
  hAxis: {
    textStyle: { fontSize: 14, color: "#333" },
  },
  vAxis: {
    ticks: [
      { v: 0, f: "None" },
      { v: 25, f: "Bad" },
      { v: 50, f: "Fair" },
      { v: 75, f: "Good" },
      { v: 100, f: "Excellent" },
    ],
    textStyle: { fontSize: 14, color: "#333" },
  },
  legend: { position: "none" },
};

const GradingScoresChart = ({ grades, getGradings }: any) => {
  const gradings = ['Reliability', 'Safety', 'Punctuality', 'Response Rate'];

  const gradeValues = [
    grades?.reliabilityScore ?? 0,
    grades?.safetyScore ?? 0,
    grades?.punctualityScore ?? 0,
    grades?.responseScore ?? 0,
  ];

  const data = [
    ["Grades", "Score", { role: "style" }],
    ...gradings.map((grade, i) => [
      grade,
      Math.round(gradeValues[i]),
      getGraphBackgroundColor(Math.round(gradeValues[i])),
    ]),
  ];

  useEffect(() => {
    getGradings();
  }, []);

  return (
    <Chart
      chartType="ColumnChart"
      width="85%"
      height="500px"
      data={data}
      options={options}
    />
  );
};

export default GradingScoresChart;
